import BarrelType from "../model/BarrelType";
import { ProjectViewTypes } from "../enums";

function getInitialBarrelView(providedUrl = window.location.href): string {
    if (providedUrl.includes("flow")) {
        return ProjectViewTypes.FLOW;
    }

    if (providedUrl.includes("styleguides")) {
        return ProjectViewTypes.STYLEGUIDE;
    }

    if (providedUrl.includes("storybook")) {
        return ProjectViewTypes.STORYBOOK;
    }

    if (providedUrl.includes("screen")) {
        return ProjectViewTypes.SCREEN;
    }

    if (providedUrl.includes("component")) {
        return ProjectViewTypes.COMPONENT;
    }

    return ProjectViewTypes.DASHBOARD;
}

function getInitialBarrelType(providedUrl = window.location.href): BarrelType {
    if (providedUrl.includes("styleguide")) {
        return BarrelType.STYLEGUIDE;
    }

    return BarrelType.PROJECT;
}

export {
    getInitialBarrelView,
    getInitialBarrelType
};
